'use es6';

import { fromJS } from 'immutable';
export const updateCustomFiltersInTemplate = template => {
  const filters = template.getIn(['config', 'filters', 'custom']).filter(filter => filter.get('property') !== 'closedate');
  const newFilters = filters.toJS();
  const currentYear = new Date().getFullYear();
  newFilters.push({
    operator: 'BETWEEN',
    values: [],
    property: 'closedate',
    dateTimeFormat: 'DATE',
    highValue: `${currentYear}-12-31`,
    value: `${currentYear}-01-01`
  });
  return template.setIn(['config', 'filters', 'custom'], fromJS(newFilters));
};